import { Raycaster } from 'three';
import { BaseClass } from 'dac-web-base';
import { GROUP_TYPE } from '../../../js/structures/aqua/gridAqua';

export class SceneGroupMouse extends BaseClass {
	
	#rayCaster = null;

	constructor() {
		super();
		this.sceneUnit = null;
		this.container = null;
		this.#rayCaster = new Raycaster();

		this._enabled = true;
	}

	init( sceneUnit, container ) {
		this.sceneUnit = sceneUnit;
		this.container = container;

		container.addEventListener( 'pointerup', async( e ) => await this.#onMouseUp( e ) );
		container.addEventListener( 'pointermove', async( e ) => await this.#onMouseMove( e ) );

		return this;
	}

	setEnabled( enabled ) {
		this._enabled = enabled;
		this.sceneUnit.controls.enabled = enabled;
	}

	async #onMouseUp( e ) {

		if( !this._enabled ) return;

		//if not mouse left button click, return
		if( e.button !== 0 ) return;
		// if not clicked on canvas, return
		if( e.target !== this.sceneUnit.renderUnit.renderer.domElement ) return;

		const intersect = this.#intersect( e );

		if( intersect.type === GROUP_TYPE.NONE ) await this.trigger( 'onFloorClicked' );
		else if( intersect.meshes.length > 0 ) await this.trigger( 'onObjectClicked', { e: e, intersect: intersect, type: intersect.type } );
	}

	async #onMouseMove( e ) {

		if( !this._enabled ) return;

		const intersect = this.#intersect( e );
		const meshes = intersect.meshes;

		await this.trigger( 'onObjectHover', { e: e, intersect: intersect, type: meshes.length > 0 ? intersect.type : '' } );
	}

	#intersect( e ) {
		
		//add a margin to the mouse position. User usually clicks with the top of the mouse
		const mousemargin = 0;

		//get what has the user collided with
		const pos = {
			x :( ( e.clientX - mousemargin ) / window.innerWidth ) * 2 - 1,
			y: - ( ( e.clientY - mousemargin ) / window.innerHeight ) * 2 + 1
		};

		// calculate objects intersecting the picking ray
		this.#rayCaster.setFromCamera( pos, this.sceneUnit.camera );

		let meshes = [];

		//against frontales
		meshes = this.#intersectArray( this.sceneUnit._gridData.frontales.children );
		if( meshes.length > 0 )
			return { type: GROUP_TYPE.FRONTALES, meshes: meshes };
		//against laterales
		meshes = this.#intersectArray( this.sceneUnit._gridData.laterales.children );
		if( meshes.length > 0 ) 
			return { type: GROUP_TYPE.LATERALES, meshes: meshes };
		//against capillas
		meshes = this.#intersectArray( this.sceneUnit._gridData.capillas.children );
		if( meshes.length > 0 )
			return { type: GROUP_TYPE.CAPILLAS, meshes: meshes };
		//against traversales
		meshes = this.#intersectArray( this.sceneUnit._gridData.traversales.children );
		if( meshes.length > 0 )
			return { type: GROUP_TYPE.TRAVERSALES, meshes: meshes };

		return { type: GROUP_TYPE.NONE, meshes: [] };
	}

	#intersectArray( array ) {
		const intersects = this.#rayCaster.intersectObjects( array );

		// avoid LineSegments
		const meshes = intersects.filter( ( i ) => !this.#isEmpty( i.object ) && this.#isVisible( i.object ) );
		if( meshes.length > 0 ) return meshes;

		return [];
	}

	#isEmpty( obj ) {
		for (const prop in obj) {
			if ( Object.hasOwn( obj, prop ) ) {
				return false;
			}
		}
 
		return true;
	}

	#isVisible( obj ) {
		if( !obj ) return true;
		if( !obj.visible ) return false;
		let visible = true;
		obj.traverseAncestors( c => {
			if( !c ) return;
			if( !c.visible ) visible = false;
		} );

		return visible;
	}
}